module.exports = __webpack_public_path__ + "static/media/disco1.b5bd916b.mp3";